<template>
	<Dropdown
		:modelValue="modelValue"
		@update:modelValue="emit('update:modelValue', $event)"
		:options="emailList"
		optionLabel="label"
		placeholder="Pilih email"
		class="w-full"
		:disabled="disabled || loadingEmails"
		:loading="loadingEmails"
		:showClear="!!modelValue"
		filter
		filterPlaceholder="Cari email"
		:resetFilterOnHide="true"
	/>
</template>

<script setup>
import { ref, watch } from 'vue';
import VendorListService from '@/service/VendorListService';

// eslint-disable-next-line no-undef
const props = defineProps({
	modelValue: {
		type: Object,
		default: null,
	},
	userId: {
		type: [Number, String],
		default: null,
	},
	companyName: {
		type: String,
		default: null,
	},
	disabled: {
		type: Boolean,
		default: false,
	},
});

// eslint-disable-next-line no-undef
const emit = defineEmits(['update:modelValue', 'loaded']);

const emailList = ref([]);
const loadingEmails = ref(false);

const loadEmails = async () => {
	if (!props.userId || !props.companyName) {
		emailList.value = [];
		return;
	}

	loadingEmails.value = true;
	try {
		const result = await VendorListService.getSetting(
			props.userId,
			props.companyName
		);

		if (result.status === 200 && result.data.data?.email_lov) {
			emailList.value = result.data.data.email_lov;
			emit('loaded', result.data.data);
		} else {
			emailList.value = [];
			console.warn('Email LOV empty or not found:', result.data);
		}
	} catch (e) {
		emailList.value = [];
		console.error('Failed to load email LOV:', e);
	} finally {
		loadingEmails.value = false;
	}
};

watch(
	() => [props.userId, props.companyName],
	([userId, companyName]) => {
		if (userId && companyName) loadEmails();
	},
	{ immediate: true }
);
</script>
